import { SESSION_COOKIE } from "@/config";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { IncomingMessage, ServerResponse } from "http";
import { NextApiRequestCookies } from "next/dist/server/api-utils";

export type Session = { token: string; expires: number };

type Req = IncomingMessage & { cookies: NextApiRequestCookies };
type Res = ServerResponse<IncomingMessage>;
export function getSessionCookie(req?: Req, res?: Res): Session | null {
  const cookie = getCookie(SESSION_COOKIE, { req, res });
  if (!cookie) return null;
  return JSON.parse(cookie);
}

export function saveSessionCookie(
  token: string,
  expires: number
): Session | null {
  const date = new Date();
  date.setMilliseconds(date.getMilliseconds() + expires);

  setCookie(
    SESSION_COOKIE,
    { token, expires },
    {
      path: "/",
      expires: date,
      maxAge: expires / 1000,
      sameSite: true,
    }
  );

  return getSessionCookie();
}

export function deleteSessionCookie() {
  deleteCookie(SESSION_COOKIE, {
    path: "/",
    sameSite: true,
  });
}
